import { Link } from 'react-router-dom';
import { formatCurrency, formatMileage } from '@cardealeros/shared';

interface VehicleCardProps {
  vehicle: {
    id: string;
    year: number | null;
    make: string | null;
    model: string | null;
    trim: string | null;
    mileage: number | null;
    asking_price_cents: number | null;
    market_value_cents: number | null;
    status: string;
    photos?: { url: string; thumbnail_url: string | null }[];
  };
}

export default function VehicleCard({ vehicle: v }: VehicleCardProps) {
  const title = [v.year, v.make, v.model].filter(Boolean).join(' ') || 'Unknown';
  const photo = v.photos?.[0];

  return (
    <Link to={`/vehicles/${v.id}`} className="card overflow-hidden hover:border-surface-600 transition-colors block">
      {/* Photo */}
      {photo ? (
        <img src={photo.thumbnail_url ?? photo.url} alt={title} className="w-full aspect-[16/10] object-cover" />
      ) : (
        <div className="w-full aspect-[16/10] bg-surface-700 flex items-center justify-center text-surface-600 text-4xl">
          ?
        </div>
      )}

      {/* Info */}
      <div className="p-3">
        <h3 className="font-semibold text-sm truncate">{title}</h3>
        <div className="flex items-center justify-between mt-1.5">
          <span className="text-brand-400 font-bold text-sm">
            {formatCurrency(v.asking_price_cents ?? v.market_value_cents)}
          </span>
          <span className="text-surface-500 text-xs">
            {formatMileage(v.mileage)} mi
          </span>
        </div>
        <span className={`inline-block mt-2 px-2 py-0.5 rounded-full text-[10px] font-medium ${
          v.status === 'active' ? 'bg-green-900/50 text-green-400' :
          v.status === 'sold' ? 'bg-blue-900/50 text-blue-400' :
          v.status === 'flagged' ? 'bg-red-900/50 text-red-400' :
          'bg-surface-700 text-surface-400'
        }`}>
          {v.status === 'flagged' ? 'mismatch' : v.status}
        </span>
      </div>
    </Link>
  );
}
